import { Link } from 'react-router-dom';
import { useClusterOverview, useClusterHealth } from '../hooks/api';
import { Loading, ErrorBox, EmptyBox } from '../components/Loading';
import { Status } from '../components/Status';
import { formatBytes, formatNumber, formatTimestamp } from '../api';

export default function ClusterOverviewPage() {
  const overview = useClusterOverview();
  const health = useClusterHealth();

  return (
    <div className="space-y-3">
      <h1 className="text-[14px] font-semibold uppercase tracking-wide text-neutral-700 border-b border-neutral-300 pb-1">
        Cluster Overview
      </h1>

      <div className="grid grid-cols-3 gap-3">
        <KpiPanel
          title="Cluster-Groesse"
          value={overview.data ? formatBytes(overview.data.cluster.size_bytes) : '–'}
        />
        <KpiPanel
          title="Datenbanken"
          value={overview.data ? formatNumber(overview.data.cluster.database_count) : '–'}
        />
        <KpiPanel
          title="Connections"
          value={
            health.data
              ? `${health.data.connections.active} / ${health.data.connections.max}`
              : '–'
          }
        />
      </div>

      <div className="panel">
        <div className="panel-h">Tenants</div>
        <div className="panel-b">
          {overview.isLoading && <Loading />}
          {overview.error && <ErrorBox error={overview.error} />}
          {overview.data && overview.data.tenants.length === 0 && (
            <EmptyBox>Keine Tenants registriert.</EmptyBox>
          )}
          {overview.data && overview.data.tenants.length > 0 && (
            <table className="tbl">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Datenbank</th>
                  <th>Status</th>
                  <th className="num">DB-Groesse</th>
                  <th className="num">Tabellen</th>
                  <th>Angelegt</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {overview.data.tenants.map((t) => (
                  <tr key={t.code}>
                    <td className="mono">{t.code}</td>
                    <td>{t.name}</td>
                    <td className="mono">{t.database_name}</td>
                    <td>
                      {t.active ? (
                        <Status kind="ok">aktiv</Status>
                      ) : (
                        <Status kind="muted">inaktiv</Status>
                      )}
                    </td>
                    <td className="num">{formatBytes(t.db_size_bytes)}</td>
                    <td className="num">{formatNumber(t.table_count)}</td>
                    <td className="mono">{formatTimestamp(t.created_at)}</td>
                    <td>
                      <Link
                        to={`/tenants/${encodeURIComponent(t.code)}`}
                        className="btn"
                      >
                        Detail
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <div className="panel">
        <div className="panel-h">Datenbanken (gesamt)</div>
        <div className="panel-b">
          {health.isLoading && <Loading />}
          {health.error && <ErrorBox error={health.error} />}
          {health.data && (
            <table className="tbl">
              <thead>
                <tr>
                  <th>Name</th>
                  <th className="num">Groesse</th>
                </tr>
              </thead>
              <tbody>
                {health.data.databases.map((d) => (
                  <tr key={d.name}>
                    <td className="mono">{d.name}</td>
                    <td className="num">{formatBytes(d.size_bytes)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

function KpiPanel({ title, value }: { title: string; value: string }) {
  return (
    <div className="panel">
      <div className="panel-h">{title}</div>
      <div className="panel-b">
        <div className="text-[20px] font-mono font-semibold text-slate-900">{value}</div>
      </div>
    </div>
  );
}
